// extracted by mini-css-extract-plugin
export default {"grid":"CustomersCards_grid__tvR6F"};